import { render, staticRenderFns } from "./DialogPeopleCreate-comp.vue?vue&type=template&id=29c85666&scoped=true&"
import script from "./DialogPeopleCreate-comp.vue?vue&type=script&lang=js&"
export * from "./DialogPeopleCreate-comp.vue?vue&type=script&lang=js&"
import style0 from "./DialogPeopleCreate-comp.vue?vue&type=style&index=0&id=29c85666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c85666",
  null
  
)

export default component.exports